<template>
  <v-dialog v-model="model" max-width="400">
    <template #activator="{ on }">
      <v-btn color="pink" class="white--text ml-2" depressed v-on="on">
        Add file
        <v-icon right> mdi-text-box-plus-outline </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pink--text"> Create File </v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="onSubmit">
          <v-file-input
            v-model="crud.archive"
            label="File"
            :rules="[rules.required]"
            clearable
            @change="onFileInput"
          />
          <v-text-field v-model="crud.name" label="Name" :rules="[rules.required]" clearable />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="pink"
          :loading="loading"
          depressed
          class="ml-auto white--text"
          @click="onSubmit"
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { rules } from "../../mixins/rulesMixin";
import { createFile } from "@/api/api";

export default {
  data() {
    return {
      rules,
      crud: {
        archive: null,
        name: "",
      },
      loading: false,
      model: false,
    };
  },
  methods: {
    onFileInput(e) {
      if (e && !this.crud.name) this.crud.name = e.name;
    },
    async onSubmit() {
      const form = this.$refs.form;
      if (!form.validate()) return;
      this.loading = true;
      try {
        const { data } = await createFile({
          ...this.crud,
          folder: (this.$route.params.path || "").split("&").at(-1),
        });

        this.$emit("new-file", {
          name: data.name,
          uuid: data.uuid,
          type: "FILE",
          ext: data.extension,
          archive: data.archive,
        });
        this.model = false;
        form.reset();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
